<script setup lang="ts">
import { useTour } from '../composables/useTour'
import { useTourProgressStore } from '../stores/tour-progress.store'

const tour = useTour()
const progress = useTourProgressStore()

function startThisScreen(): void {
  tour.startCurrentScreen()
}
function toggleTraining(): void {
  tour.setTrainingModeAllScreens(!progress.trainingModeAllScreens)
}
function openGuide(): void {
  tour.openExplore()
}
</script>

<template>
  <v-menu location="bottom end" offset="8">
    <template #activator="{ props: menu }">
      <v-tooltip text="Help & tutorials" location="bottom">
        <template #activator="{ props: tip }">
          <v-btn
            v-bind="{ ...menu, ...tip }"
            icon
            variant="text"
            size="small"
            class="mx-1"
            aria-label="Help and tutorials"
            data-tour="help-button"
          >
            <i class="fa-solid fa-circle-question help-btn__icon" />
          </v-btn>
        </template>
      </v-tooltip>
    </template>

    <v-list density="comfortable" min-width="260" class="help-menu">
      <v-list-subheader>Learn this platform</v-list-subheader>

      <v-list-item
        :disabled="!tour.hasCurrentTour.value"
        prepend-icon="fa-solid fa-play"
        title="Tutorial for this screen"
        subtitle="Guided, step by step"
        @click="startThisScreen"
      />

      <v-list-item
        prepend-icon="fa-solid fa-compass"
        title="Open screen guide"
        subtitle="Benefits, tips, FAQ & AI actions"
        @click="openGuide"
      />

      <v-divider class="my-1" />

      <v-list-item @click="toggleTraining">
        <template #prepend>
          <i
            class="fa-solid"
            :class="progress.trainingModeAllScreens ? 'fa-toggle-on' : 'fa-toggle-off'"
            style="width: 24px"
          />
        </template>
        <v-list-item-title>Training mode</v-list-item-title>
        <v-list-item-subtitle>
          {{ progress.trainingModeAllScreens ? 'On — auto-guides new screens' : 'Off — help button only' }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped lang="scss">
.help-menu {
  border-radius: 12px;
}

// Yellow help icon — more visible against the top bar in both themes.
.help-btn__icon {
  color: #f5a623;
}
</style>
